import { Component, OnInit } from '@angular/core';
import {request_lang} from '../../language/request';
import { ActivatedRoute } from '@angular/router';
import { MyserviceService } from '../../provider/myservice.service';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { ErrorStateMatcher } from '@angular/material';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
declare var $;
@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent implements OnInit {
  lang="TH";
  constructor(private route:ActivatedRoute,private service:MyserviceService) { }
  actions=[
    {id:0,name:"title",url:""},
    {id:1,name:"add_request",url:"request/create"},
    {id:2,name:"edit_request",url:"request/update"}
  ]
  action=this.actions[0];
  requests=[];
  submitted=false;
  subjects=[];
  // myControl = new FormControl();
  users=[];
  subject:any={};
  detail="";
  isLoading=true;
  request_search={start_date:"",end_date:"",sub_id:"",detail:"",username:"",requestor:""}
  // filteredSubject:any=[];

  myControl = new FormControl();
  customerControl = new FormControl();
  customer:any={};
  filteredOptions: Observable<any[]>;
  filteredCustomer=[];
  id:""
  matcher = new MyErrorStateMatcher();
  customers=[];

  //drop down 
  dropdownSettings:IDropdownSettings = {
    singleSelection: true,
    idField: 'customer_id',
    textField: 'customer_fullname',
    selectAllText: 'เลือกทั้งหมด',
    unSelectAllText: 'ไม่เลือกทั้งหมด',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  ngOnInit() {

    this.service.postData({},"subject/get").then((result:any)=>{
      this.subjects=result.data;
      this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.subject_text),
        map(subject_text => subject_text ? this._filter(subject_text) : this.subjects.slice())
      );
    })

    this.service.postData({},"customer/get").then((result:any)=>{

      this.customers=result.data;
      console.log(result);
      
      this.filteredCustomer = [];
      if (this.customers.length > 20) 
      {
        for (var i=0;i<=20-1;i++) 
        {
          this.filteredCustomer.push(this.customers[i]);
        }
      }
      else 
      {
        for (var i=0;i<=this.customers.length-1;i++) 
        {
          this.filteredCustomer.push(this.customers[i]);
        }
      }
    })
    this.service.postData({},"get_user").then((result:any)=>{
      this.users=result.data;
    })
    this.route.queryParams.subscribe(params => {
      this.lang= params['lang'];
      if(this.lang!='EN'&&this.lang!='TH'){
        this.lang=localStorage.getItem('lang')=='EN'?'EN':'TH';
        // this.language=cus_lange[this.lang];
      }else{
        // this.language=cus_lange[this.lang];
        localStorage.setItem('lang',this.lang);
      }
   });
   this.refresh();
  }
  change_subject(){
    setTimeout(()=>{
      $("#username").click();
     },500);
  }
  change_username(){
    setTimeout(()=>{
      $("#detail").focus();
    },400);
  }
  displayFn(subject?): string | undefined {
    return subject ? subject.subject_text : undefined;
  }
  displayCustomer(customer?): string | undefined {
    return customer ? customer.customer_name?(customer.customer_name +' '+customer.customer_surname):undefined: undefined;
  }
  private _filter(subject_text: string): any[] {
    const filterValue = subject_text.toLowerCase();

    return this.subjects.filter(option => option.subject_text.toLowerCase().indexOf(filterValue) === 0);
  }
  private _filterCustomer(subject_text: string): any[] {
    const filterValue = subject_text.toLowerCase();

    return this.customers.filter(option => (option.customer_name+' '+option.customer_surname).toLowerCase().indexOf(filterValue) === 0);
  }
  subject_input(){

  }
  search(){
    if(this.request_search.start_date==null){
      this.request_search.start_date="";
    }
    if(this.request_search.end_date==null){
      this.request_search.end_date=""
    }
    this.isLoading=true;
    this.service.postData(this.request_search,"request/get").then((result:any)=>{
      if(!result.code){
        this.requests=result.data.map((item)=>{
          item.detail_show=item.detail.length>50?item.detail.substring(0,50)+"...":item.detail;
          return item;
        });

      }
      this.isLoading=false;
    },err=>{
      this.isLoading=false;
    })

  }
  clear(){
    this.request_search={start_date:"",end_date:"",sub_id:"",detail:"",username:"",requestor:""};
    this.search();
  }
  add(){
    this.action=this.actions[1];
    setTimeout(()=>{
      $("#subject").focus();
    },500);
  }
  delete_request(item){
    Swal.fire({
      title: this.$t('delete_title'),
      text: this.$t('delete_warning'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.$t('delete'),
      cancelButtonText: this.$t('cancel')
    }).then((result) => {
      if (result.value) {
        this.service.postData(item, "request/delete").then((result:any) => {
          if(!result.code){
            Swal.fire({
                  title: this.$t('deleted'),
                  text: '',
                  type: 'success',
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer:2000
            }).then((result) => {
                    this.refresh();
            })
          }
        }, err => {
          window.location.href=this.service.start_host
        })
      }
    })
  }
  refresh(){
    this.submitted=false;
    this.customer={};
    this.subject={};
    this.detail="";
    this.action=this.actions[0];
    this.search();
  }
  invalid(){
    return {
      subject:this.submitted&&JSON.stringify(this.subject)=='{}',
      username:this.submitted&&JSON.stringify(this.customer)=='{}',
      detail:this.submitted&&this.detail==""
    }
  }
  body(){
    return {
      request_id:this.id,
      sub_id:this.subject.sub_id,
      username:JSON.parse(sessionStorage.getItem('user')).username,
      detail:this.detail,
      requestor:this.customer[0].customer_id
    }
  }
  isValid(){
    var valid=true;
    for(var i in this.invalid()){
     if( this.invalid()[i]){
       valid=false;
     }
    }
    return valid;
  }
  edit(request){
    this.action=this.actions[2];
    var s=this.subjects.filter((item)=>item.sub_id==request.sub_id);
    if(s.length>0){
      this.subject=s[0];
    }
    console.log(request);
    var u=this.customers.filter((item)=>item.customer_id==request.requestor);
    if(u.length>0){
      this.customer=u[0];
    }
    console.log(u);
    this.detail=request.detail;
    this.id=request.request_id;
    setTimeout(()=>{
      $("#subject").focus();
    },500);
  }
  save(){
    this.submitted=true;
    if(this.isValid()){
      this.service.postData(this.body(),this.action.url).then((result:any)=>{
        if(!result.code){
          Swal.fire({
            title:  this.$t('saved'),
            text: '',
            type: 'success',
            showCancelButton: false,
            showConfirmButton: false,
            timer:2000
          }).then((result)=>{
           this.refresh();
          })
        }
      })
    }

  }
  
  $t(text){
    if(request_lang[this.lang][text]==undefined){
      return text;
    }else{
      return request_lang[this.lang][text];
    }
  }


  onItemSelect(item: any) {
    console.log(this.customer);
  }
  onSelectAll(items: any) 
  {
    console.log(this.customer);
    this.customer = [];
    this.customer = items;
  }

  onItemDeSelect(deitem: any) {
    console.log(this.customer);
  }
  onDeSelectAll(items: any) {
    this.customer = [];
    console.log(this.customer);
  }

  onFilterCustomer(item: any)
  {
    console.log(item);
    if (item.length >= 2) 
    {
      this.filteredCustomer = [];
      var filteredCustomer = this._filterCustomer(item)

      if (filteredCustomer.length > 0) 
      {
        if (filteredCustomer.length > 20) 
        {
          for (var i=0;i<=20-1;i++) 
          {
            this.filteredCustomer.push(filteredCustomer[i]);
          }
        }
        else 
        {
          for (var i=0;i<=filteredCustomer.length-1;i++) 
          {
            this.filteredCustomer.push(filteredCustomer[i]);
          }
        }
        
      }
      else 
      {
        if (this.customers.length > 20) 
        {
          for (var i=0;i<=20-1;i++) 
          {
            this.filteredCustomer.push(this.customers[i]);
          }
        }
        else 
        {
          for (var i=0;i<=this.customers.length-1;i++) 
          {
            this.filteredCustomer.push(this.customers[i]);
          }
        }
      }
    }
  }
}
